(() => {
  const ROOT = '[data-plexigo-qr-selector]';

  const normalizeInstagram = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^https?:\/\//i.test(raw)) return raw;
    const username = raw.replace(/^@+/, '').replace(/^(www\.)?instagram\.com\//i, '').split(/[/?#]/)[0];
    return username ? `https://instagram.com/${username}` : raw;
  };

  const normalizeTelegram = (value) => {
    const raw = String(value || '').trim();
    if (!raw || /^https?:\/\//i.test(raw)) return raw;
    return `https://t.me/${raw.replace(/^@+/, '').replace(/^(www\.)?t\.me\//i, '').split(/[/?#]/)[0]}`;
  };

  const normalizeTiktok = (value) => {
    const raw = String(value || '').trim();
    if (!raw || /^https?:\/\//i.test(raw)) return raw;
    return `https://www.tiktok.com/@${raw.replace(/^@+/, '').replace(/^(www\.)?tiktok\.com\/@?/i, '').split(/[/?#]/)[0]}`;
  };

  const normalizeWhatsApp = (value) => {
    const raw = String(value || '').trim();
    if (!raw || /^https?:\/\//i.test(raw)) return raw;
    let digits = raw.replace(/\D/g, '');
    if (digits.startsWith('0')) digits = `90${digits.slice(1)}`;
    else if (digits.length === 10) digits = `90${digits}`;
    return digits ? `https://wa.me/${digits}` : raw;
  };

  const formatIban = (value) => String(value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').replace(/(.{4})/g, '$1 ').trim();

  function init(root) {
    if (!root || root.dataset.plexigoQrReady === 'true') return;
    root.dataset.plexigoQrReady = 'true';
    const form = root.closest('form');
    if (!form) return;

    const max = Math.max(1, Number(root.dataset.maxSelections || 1));
    const checkboxes = [...root.querySelectorAll('[data-plexigo-qr-checkbox]')];
    const choices = [...root.querySelectorAll('[data-plexigo-qr-choice]')];
    const details = [...root.querySelectorAll('[data-plexigo-qr-detail]')];
    const counter = root.querySelector('[data-plexigo-qr-counter]');
    const more = root.querySelector('[data-plexigo-qr-more]');
    const toggle = root.querySelector('[data-plexigo-qr-toggle]');
    const toggleText = root.querySelector('[data-plexigo-qr-toggle-text]');
    const error = root.querySelector('[data-plexigo-qr-error]');
    const slots = [...root.querySelectorAll('[data-plexigo-qr-slot]')];
    const logo = root.querySelector('[data-plexigo-generic-logo]');
    let selectedOrder = [];

    const setError = (message = '') => {
      if (!error) return;
      error.textContent = message;
      error.hidden = !message;
    };

    const detailFor = (value) => details.find((el) => el.dataset.plexigoQrDetail === value);
    const selectedValues = () => selectedOrder.filter((value) => checkboxes.some((cb) => cb.checked && cb.value === value));

    function setDetailActive(detail, active) {
      if (!detail) return;
      detail.hidden = !active;
      detail.dataset.plexigoSelected = active ? 'true' : 'false';
      detail.querySelectorAll('input, textarea, select').forEach((input) => {
        if (input.matches('[data-plexigo-place-search], [data-plexigo-manual-name], [data-plexigo-manual-link]')) {
          input.disabled = !active;
          return;
        }
        if (input.hasAttribute('data-plexigo-qr-input') || input.name?.startsWith('properties[')) input.disabled = !active;
      });
      detail.querySelector('[data-plexigo-google-business]')?.dispatchEvent(new CustomEvent('plexigo:conditional-change'));
    }

    function syncSlots() {
      const values = selectedValues();
      slots.forEach((slot, index) => {
        const value = values[index] || '';
        slot.value = value;
        slot.disabled = !value;
      });
    }

    function sync() {
      selectedOrder = selectedValues();
      const count = selectedOrder.length;
      if (counter) counter.textContent = `${count} / ${max}`;
      checkboxes.forEach((cb) => {
        const choice = cb.closest('[data-plexigo-qr-choice]');
        const active = cb.checked;
        choice?.classList.toggle('is-selected', active);
        const blocked = !active && count >= max;
        cb.disabled = blocked;
        choice?.classList.toggle('is-disabled', blocked);
        setDetailActive(detailFor(cb.value), active);
      });
      syncSlots();
      if (count) setError('');
    }

    checkboxes.forEach((cb) => {
      cb.addEventListener('change', () => {
        if (cb.checked) {
          if (!selectedOrder.includes(cb.value)) selectedOrder.push(cb.value);
          if (selectedOrder.length > max) {
            cb.checked = false;
            selectedOrder = selectedOrder.filter((v) => v !== cb.value);
            setError(`Bu modelde en fazla ${max} seçim yapabilirsiniz.`);
          }
        } else {
          selectedOrder = selectedOrder.filter((v) => v !== cb.value);
        }
        sync();
      });
    });

    toggle?.addEventListener('click', () => {
      const open = more?.hidden !== false;
      if (more) more.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (toggleText) toggleText.textContent = open ? 'Daha az göster' : 'Daha fazla göster';
      toggle.classList.toggle('is-open', open);
    });

    root.querySelectorAll('input[type="file"]').forEach((input) => {
      input.addEventListener('change', () => {
        const nameEl = input.closest('.plexigo-upload-field')?.querySelector('[data-plexigo-file-name]');
        if (nameEl) nameEl.textContent = input.files?.[0]?.name || 'Henüz dosya seçilmedi';
      });
    });

    root.querySelectorAll('[data-plexigo-kind="iban"]').forEach((input) => {
      input.addEventListener('input', () => { input.value = formatIban(input.value); });
    });

    root.querySelectorAll('[data-plexigo-kind]').forEach((input) => {
      input.addEventListener('blur', () => {
        if (!input.value.trim()) return;
        switch (input.dataset.plexigoKind) {
          case 'instagram': input.value = normalizeInstagram(input.value); break;
          case 'telegram': input.value = normalizeTelegram(input.value); break;
          case 'tiktok': input.value = normalizeTiktok(input.value); break;
          case 'whatsapp': input.value = normalizeWhatsApp(input.value); break;
          case 'iban': input.value = formatIban(input.value); break;
        }
      });
    });

    function fieldLabel(input) {
      return input.closest('label')?.querySelector(':scope > span:first-child')?.textContent?.trim() || 'Bu alan';
    }

    function validateFile(input) {
      const file = input.files?.[0];
      if (!file) return false;
      const maxSize = Number(input.dataset.maxSize || 0);
      return !(maxSize && file.size > maxSize);
    }

    form.addEventListener('submit', (event) => {
      const selected = selectedValues();
      if (!selected.length) {
        event.preventDefault();
        event.stopImmediatePropagation();
        setError('Devam etmek için en az 1 QR içeriği seçin.');
        root.querySelector('.plexigo-qr-selector__card')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      for (const value of selected) {
        const detail = detailFor(value);
        if (!detail) continue;
        if (value === 'Google Yorum') {
          const review = detail.querySelector('[data-plexigo-property-review-uri]');
          if (!review?.value) {
            event.preventDefault();
            event.stopImmediatePropagation();
            setError('Google Yorum için işletmenizi seçin.');
            detail.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          continue;
        }

        const requiredInputs = [...detail.querySelectorAll('[data-plexigo-qr-input]')];
        for (const input of requiredInputs) {
          const valid = input.type === 'file' ? validateFile(input) : Boolean(String(input.value || '').trim());
          if (!valid) {
            event.preventDefault();
            event.stopImmediatePropagation();
            const msg = input.type === 'file' ? `${value} için gerekli dosyayı yükleyin.` : `${fieldLabel(input)} zorunludur.`;
            setError(msg);
            detail.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => input.focus?.(), 250);
            return;
          }
        }
      }

      if (logo?.files?.[0]) {
        const maxSize = Number(logo.dataset.maxSize || 0);
        if (maxSize && logo.files[0].size > maxSize) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setError('Logo dosyası 10 MB’dan küçük olmalıdır.');
          logo.closest('.plexigo-custom-card')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }

      setError('');
    }, true);

    sync();
  }

  const initAll = (scope = document) => scope.querySelectorAll?.(ROOT).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      if (node.matches?.(ROOT)) init(node);
      initAll(node);
    }));
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
